import {BasePqmFieldValue} from "./BasePqmFieldValue";
import {PqmFieldRegister} from "./PqmFieldRegister";
import {Htmlarea} from "../../Htmlarea";
import {isHTMLStringEmpty} from "../../Utils";

export class PqmFieldText extends BasePqmFieldValue {
	static getValueTypes(): string[] {
		return [ "string:multiLine", "string:singleLine", "string:html" ];
	}

	beforeIndex() {
		// @ts-ignore
		this.muAppendContent({
			'multiLine': '<textarea mu="value#value" class="form-control"></textarea>',
			'singleLine': '<input type="text" mu="value#value" class="form-control" />',
			'html': '<div mu="value:Htmlarea#value"></div>',
		}[this.control]);
	}

	isFilled(): boolean {
		if (this.control === "string:html") {
			return (this.muNamedWidget.value as unknown as Htmlarea).isInitialized()
				&& !isHTMLStringEmpty(this.getValue());
		} else return super.isFilled();
	}

	async afterIndex() {
		if (this.muNamedWidget.value) {
			super.afterIndex();
			await (this.muNamedWidget.value as unknown as Htmlarea).waitForInit();
			this.onChange();
		}
	}

	setDisabled(disabled: boolean) {
		if (this.muNamedWidget.value)
			(this.muNamedWidget.value as unknown as Htmlarea).setDisabled(disabled);
		else
			this.ui.value.disabled = disabled;
	}
}

PqmFieldRegister.register(PqmFieldText);